<!--
   Created by qing on 2020/10/14
   Des:
-->
<template>

  <van-cell class="ry-form__item-relate-record">
    <template slot="title">
      <span class="title">{{current.title}}</span>
    </template>
    <template slot="label">

      <template v-if="current.fieldHint">
        <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
        <div
          v-else
          class="ql-editor"
          v-html="current.fieldHint">
        </div>
      </template>

      <div v-if="isRead">
        <div v-if="current.value.instanceIdList.length">

          <template v-if="valueList.length">
            <div
              v-if="current.showStyle === 'CARD'"
              class="data-source-container">
              <div
                class="card-item"
                v-for="item in valueList"
                @click="rowClick(item)"
                :key="item.instanceId">
                <div class="preview-card">
                  <div class="preview-card-wrapper">
                    <div class="card-info">
                      <h3 v-if="item.title">{{item.title.showData}}</h3>
                      <div class="card-info-row">
                        <div
                          class="row-item"
                          :style="{width: `${100 / item.content.length}%`}"
                          v-for="showData in item.content"
                          :key="showData.fieldId">
                          <h5>{{showData.fieldTitle}}</h5>
                          <div class="item-content">
                            <FieldShowData :show-data="showData"></FieldShowData>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="img-container"
                      v-if="item.image && item.image.showData">
                      <el-image :src="item.image.showData" fit="cover"></el-image>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-else>
              {{valueList[0].title.showData}}
            </div>
          </template>

        </div>
        <div v-else>
          暂无内容
        </div>
      </div>

      <div v-if="!isRead" class="record-container">
        <template v-if="current.showStyle === 'CARD'">
          <div class="add-btn" @click="onClickAdd">
            <i class="el-icon-plus"></i>
            从「{{relateFormName}}」添加关联记录
          </div>

          <div
            class="data-source-container"
            v-if="valueList.length">
            <div
              class="card-item"
              v-for="item in valueList"
              @click="rowClick(item)"
              :key="item.instanceId">
              <div class="preview-card">
                <div class="preview-card-wrapper">
                  <div class="card-info">
                    <h3 v-if="item.title">{{item.title.showData}}</h3>
                    <div class="card-info-row">
                      <div
                        class="row-item"
                        :style="{width: `${100 / item.content.length}%`}"
                        v-for="showData in item.content"
                        :key="showData.fieldId">
                        <h5>{{showData.fieldTitle}}</h5>
                        <div class="item-content">
                          <FieldShowData :show-data="showData"></FieldShowData>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="img-container"
                    v-if="item.image && item.image.showData">
                    <el-image :src="item.image.showData" fit="cover"></el-image>
                  </div>
                </div>
              </div>
              <div v-if="!isRead && !isReadOnly" class="delete-button" @click.stop="onClickDeleteItem(item)">
                <i class="el-icon-remove"></i>
              </div>
            </div>
          </div>
        </template>

        <template v-else>
          <div class="ry-form__dropdown-input" @click="openSelect">
            <div class="select-item">
              <span v-if="valueList.length" style="color: #333333">
                 {{valueList[0].title.showData}}
              </span>
              <span v-else style="color: #959699">{{`从${relateFormName}添加关联记录`}}</span>
            </div>
            <van-icon
              v-if="valueList.length"
              name="close"
              class="close-btn"
              @click.stop="clearData">
            </van-icon>
          </div>

          <div @click.stop.prevent>
            <van-action-sheet
              class="relate-record-action-sheet"
              v-model="show"
              :title="current.title"
              get-container="body"
              @select="onSelect"
              :close-on-click-action="true"
              :actions="selectDataList">
            </van-action-sheet>
          </div>
        </template>
      </div>

      <RySelectPopup
        v-if="current.showStyle === 'CARD'"
        :title="current.title"
        :page-conf="pageConf"
        :loading="loading"
        :multiple="current.relateCount === 'MANY'"
        :is-add-btn="Boolean(current.allowAdd && hasFillForm && !$route.path.includes('/link/posting'))"
        :relateFormName="relateFormName"
        :relateAppId="current.relateAppId"
        :relateFormId="current.relateFormId"
        :fetchData="fetchData"
        :refreshData="refreshData"
        ref="rrSelectDialog"
        @selectComplete="selectRecordComplete">
      </RySelectPopup>


      <RySelectPopup
        v-if="current.pluginConfig && current.pluginConfig.entryId"
        ref="rySelectPopup"
        :title="current.title"
        @selectComplete="selectComplete">
      </RySelectPopup>
    </template>

  </van-cell>

</template>

<script>
  import {current} from './mixin'
  import {DATE_TYPE__SECTION, FORM_ITEM__DATE, FORM_TYPE__EDIT} from "../types";
  import {arrayRemove, formatDate, clone, isString} from "../../../assets/js/Untis";
  import FieldShowData from "../../component/FieldShowData";

  export default {
    mixins: [current],
    data() {
      return {
        relateFormName: '',
        hasFillForm: false,
        loading: false,
        // 分页配置
        pageConf: {
          pageSize: 20,
          currentPage: 0,
          totalPage: 1,
          totalCount: 1,
        },
        fieldList: [],
        valueList: [],
        isSelectFirst: false,
        // 关联数据视图，需要用到里面设置的隐藏字段
        hiddenFieldList: [],

        // 组件原始的value
        currentValue: {},

        //下拉框数据源
        selectDataList: [],
        show: false,
      }
    },
    components: {
      FieldShowData
    },
    computed: {
      selectValue: {
        set(val) {
          this.current.value.instanceIdList.splice(0, this.current.value.instanceIdList.length, val)
        },
        get() {
          return this.current.value.instanceIdList.length ? this.current.value.instanceIdList[0] : ''
        }
      }
    },
    created() {
      this.currentValue = clone(this.current.value)
      if (!this.current.relateAppId || !this.current.relateFormId) {
        return
      }
      // 获取权限
      this.$store.dispatch('actionFormFillPermission', {
        appId: this.current.relateAppId,
        formId: this.current.relateFormId,
      }).then(res => {
        this.hasFillForm = res.hasPer
      }).catch(console.error)

      this.$store.dispatch('actionLiteMergeStructure', {
        appId: this.current.relateAppId,
        formId: this.current.relateFormId,
      }).then(resultObject => {
        this.fieldList = resultObject.detailInfo.fieldList
        this.relateFormName = resultObject.detailInfo.formName
        this.fetchSubmitFilterData()

        if (this.current.showStyle === 'DROPDOWN') {
          this.fetchSelectData()
        }
      }).catch(console.error)

      if (this.current.relateView && this.current.relateViewId) {
        this.$store.dispatch('actionFetchFormViewDetail', {
          appId: this.current.relateAppId,
          formId: this.current.relateFormId,
          viewId: this.current.relateViewId
        }).then(resultObject => {
          this.hiddenFieldList = resultObject.hiddenFieldList
        })
      }
    },
    methods: {
      // 获取之前提交的数据
      fetchSubmitFilterData() {
        if (!this.current.value || !this.current.value.instanceIdList || !this.current.value.instanceIdList.length) {
          this.valueList.splice(0, this.valueList.length)
          return
        }

        this.$store.dispatch('actionApplyBatch', {
          appId: this.current.relateAppId,
          formId: this.current.relateFormId,
          instanceIdList: this.current.value.instanceIdList
        }).then(({currentPage, dataList, totalPage, totalCount, timestamp}) => {

          let showDataList = []
          dataList.forEach((item, idx) => {
            let showData = {
              title: {},
              image: {},
              content: [],
              item
            }
            // title
            if (this.current.titleFieldId) {
              const field = this.fieldList.filter(field => field.dataId === this.current.titleFieldId)[0]
              let val = item[this.current.titleFieldId]
              if (field.type === FORM_ITEM__DATE) {
                let format = 'yyyy-MM-dd'
                if (field.dateType === DATE_TYPE__SECTION) {
                  format = 'yyyy-MM-dd HH:mm'
                }
                val = item[this.current.titleFieldId] ? formatDate(item[this.current.titleFieldId])(format) : ''
              }
              showData.title = {
                showData: val,
                fieldId: this.current.titleFieldId,
                type: 'title'
              }
            } else {
              showData.title = {
                showData: '请设置关联的显示标题',
                fieldId: 'title',
                type: 'title'
              }
            }
            // 图片
            if (this.current.coverImageFieldId) {
              const imgArr = item[this.current.coverImageFieldId]
              showData.image = {
                showData: imgArr && imgArr.length > 0 ? imgArr[0].imgUrl : '',
                fieldId: this.current.coverImageFieldId,
                type: 'image'
              }
            }
            this.current.showFieldIdList.forEach(fieldId => {
              let field = this.fieldList.filter(field => field.dataId === fieldId)[0]
              if (field) {
                showData.content.push({
                  showData: item[fieldId],
                  type: field.type,
                  ...field
                })
              }
            })
            showDataList.push(showData)
          })
          this.valueList.splice(0, this.valueList.length, ...showDataList)
        })
          .catch(console.error)
          .finally(() => {
            this.loading = false
          })
      },

      // 点击添加关联记录
      onClickAdd() {
        if (!this.current.relateAppId || !this.current.relateFormId) {
          this.$toast.fail('关联信息未设置，请完善关联信息')
          return
        }
        this.loading = true
        this.pageConf.currentPage = 0
        this.pageConf.totalPage = 1
        this.pageConf.totalCount = 1
        if (this.$refs.rrSelectDialog) {
          this.$refs.rrSelectDialog.open()
        }
        this.fetchData('replace')
      },

      // 获取数据源
      fetchData(flag) {
        this.loading = true
        this.pageConf.currentPage++
        this.$store.dispatch('actionFetchRelateFormData', {
          appId: this.current.relateAppId,
          formId: this.current.relateFormId,
          data: this.current.root.getValues(),
          filterInfo: this.current.filterInfo,
          currentPage: this.pageConf.currentPage,
          pageSize: this.pageConf.pageSize,
        }).then(({currentPage, dataList, totalPage, totalCount, timestamp}) => {

          let showDataList = []
          dataList.forEach((item, idx) => {
            let showData = {
              title: {},
              image: {},
              content: [],
              item
            }
            // title
            if (this.current.titleFieldId) {
              const field = this.fieldList.filter(field => field.dataId === this.current.titleFieldId)[0]
              let val = item[this.current.titleFieldId]
              if (field.type === FORM_ITEM__DATE) {
                let format = 'yyyy-MM-dd'
                if (field.dateType === DATE_TYPE__SECTION) {
                  format = 'yyyy-MM-dd HH:mm'
                }
                val = item[this.current.titleFieldId] ? formatDate(item[this.current.titleFieldId])(format) : ''
              }
              showData.title = {
                showData: val,
                fieldId: this.current.titleFieldId,
                type: 'title'
              }
            } else {
              showData.title = {
                showData: '请设置关联的显示标题',
                fieldId: 'title',
                type: 'title'
              }
            }
            // 图片
            if (this.current.coverImageFieldId) {
              const imgArr = item[this.current.coverImageFieldId]
              showData.image = {
                showData: imgArr && imgArr.length > 0 ? imgArr[0].imgUrl : '',
                fieldId: this.current.coverImageFieldId,
                type: 'image'
              }
            }
            this.current.showFieldIdList.forEach(fieldId => {
              let field = this.fieldList.filter(field => field.dataId === fieldId)[0]
              if (field) {
                showData.content.push({
                  showData: item[fieldId],
                  type: field.type,
                  ...field
                })
              }
            })
            showDataList.push(showData)
          })

          const selectList = showDataList.filter(item => this.current.value.instanceIdList.includes(item.item.instanceId))
          console.log('selectList-----', selectList, showDataList)
          if (this.isSelectFirst) {
            // 这里是添加数据后，自动选择添加的这条数据
            if (this.$refs.rrSelectDialog) {
              // 清空dialog里面所选的数据，重新构建选择的数据，因为数据源表动，数据源里的对象内存地址变了，需要重新构建选择的数据
              const selectIds = this.$refs.rrSelectDialog.selectList.map(item => item.item.instanceId)
              selectList.splice(0, selectList.length, ...showDataList.filter(item => selectIds.includes(item.item.instanceId)))
              this.$refs.rrSelectDialog.selectList.splice(0, this.$refs.rrSelectDialog.selectList.length)
            }
            if (this.current.relateCount === 'MANY') {
              selectList.unshift(showDataList[0])
            } else {
              selectList.splice(0, selectList.length, showDataList[0])
            }
            this.isSelectFirst = false
          }

          if (this.$refs.rrSelectDialog) {
            if (flag && isString(flag)) {
              this.$refs.rrSelectDialog.setDataList(showDataList)
            } else {
              this.$refs.rrSelectDialog.appendDataList(showDataList)
            }
            this.$refs.rrSelectDialog.addSelectList(selectList)
          }

          this.pageConf.totalPage = totalPage
          this.pageConf.currentPage = currentPage
          this.pageConf.totalCount = totalCount
        })
          .catch(console.error)
          .finally(() => {
            this.loading = false
          })
      },

      // 刷新数据源
      refreshData() {
        console.log('refreshData')
        this.isSelectFirst = true
        this.pageConf.currentPage = 0
        this.pageConf.totalPage = 1
        this.pageConf.totalCount = 1
        this.fetchData('replace')
      },

      // 选择数据完成
      selectRecordComplete(selectList) {
        console.log(selectList)
        const itemList = selectList.map(item => item.item)
        const instanceIdList = selectList.map(item => item.item.instanceId)

        this.current.deleteInstanceList.splice(0, this.current.deleteInstanceList.length)
        this.current.addInstanceList.splice(0, this.current.addInstanceList.length)
        this.currentValue.instanceIdList.forEach(id => {
          if (!instanceIdList.includes(id)) {
            // 过滤出删除的id
            this.current.deleteInstanceList.push(id)
          }
        })
        instanceIdList.forEach(id => {
          if (!this.currentValue.instanceIdList.includes(id)) {
            // 过滤出增加的id
            this.current.addInstanceList.push(id)
          }
        })

        this.current.value.instanceIdList.splice(0, this.current.value.instanceIdList.length, ...itemList.map(item => item.instanceId))
        this.current.value.appId = this.current.relateAppId
        this.current.value.formId = this.current.relateFormId
        this.current.value.viewId = this.current.relateViewId

        this.controlChange()
        this.submitData()
        console.log('value', this.current.value)
      },

      // 数据点击
      rowClick(item) {
        if (!this.isRead) {
          return
        }
        const dataList = this.valueList.map(item => item.item)
        let index = 0
        for (let i = 0; i < dataList.length; i++) {
          if (dataList[i].instanceId === item.item.instanceId) {
            index = i
            break
          }
        }
        let showFields = this.fieldList.filter(item => !this.hiddenFieldList.includes(item.dataId)).map(item => item.dataId)
        console.log('showFields', this.hiddenFieldList, showFields)

        const toast = this.$toast.loading({
          message: '加载中...'
        })
        if (this.current.relateView && this.current.relateViewId) {
          const param = {
            instanceId: item.item.instanceId,
            showFields,
            viewId: this.current.relateViewId,
            appId: this.current.relateAppId,
            formId: this.current.relateFormId,
          }
          const toast = this.$toast.loading({
            message: '加载中...'
          })
          this.$store.dispatch('reqNodeSave', param).then(res => {
            this.$router.push({
              name: 'formViewDataDetail',
              query: {
                key: res.nodeKey
              }
            })
          })
            .catch(console.error)
            .finally(() => {
              toast.clear()
            })
        } else {

          const param = {
            instanceId: item.item.instanceId,
            showFields,
            appId: this.current.relateAppId,
            formId: this.current.relateFormId,
          }

          this.$store.dispatch('reqNodeSave', param).then(res => {
            this.$router.push({
              name: 'formDataDetail',
              query: {
                key: res.nodeKey
              }
            })
          })
            .catch(console.error)
            .finally(() => {
              toast.clear()
            })
        }

      },

      // 删除选择的数据
      onClickDeleteItem(item) {
        arrayRemove(this.current.value.instanceIdList, item.item.instanceId)
        arrayRemove(this.valueList, item)
        this.controlChange()
        this.submitData()
      },

      /*********下拉框模式***********/
      openSelect() {

        // 没有设置title字段，就不用请求
        if (!this.current.titleFieldId) {
          this.$toast.fail('请设置关联的显示标题')
          return
        }

        if (!this.current.relateAppId || !this.current.relateFormId) {
          this.$toast.fail('关联信息未设置，请完善关联信息')
          return
        }
        // 已经请求过数据，不用再请求了
        if (this.selectDataList && this.selectDataList.length) {
          this.show = true
          return
        }
        const toast = this.$toast.loading({message: '加载中'})
        this.fetchSelectData(() => {
          this.show = true
          toast.close()
        })
      },
      // 获取下拉框数据源
      fetchSelectData(callback) {
        // 没有设置title字段，就不用请求
        if (!this.current.titleFieldId) {
          return
        }
        if (!this.current.relateAppId || !this.current.relateFormId) {
          return
        }
        // 已经请求过数据，不用再请求了
        if (this.selectDataList && this.selectDataList.length) {
          return
        }
        this.$store.dispatch('actionApplyList', {
          appId: this.current.relateAppId,
          formId: this.current.relateFormId,
          currentPage: 1,
          pageSize: 100
        }).then(({currentPage, dataList, totalPage, totalCount, timestamp}) => {

          let showDataList = []
          dataList.forEach((item, idx) => {
            let showData = {
              name: '',
              value: item.instanceId
            }
            // title
            if (this.current.titleFieldId) {
              const field = this.fieldList.filter(field => field.dataId === this.current.titleFieldId)[0]
              let val = item[this.current.titleFieldId]
              if (field.type === FORM_ITEM__DATE) {
                let format = 'yyyy-MM-dd'
                if (field.dateType === DATE_TYPE__SECTION) {
                  format = 'yyyy-MM-dd HH:mm'
                }
                val = item[this.current.titleFieldId] ? formatDate(item[this.current.titleFieldId])(format) : ''
              }
              showData.name = val
            }
            showDataList.push(showData)
          })
          this.selectDataList.splice(0, this.selectDataList.length, ...showDataList)
        })
          .catch(console.error)
      },
      clearData() {
        this.current.value.instanceIdList.splice(0, this.current.value.instanceIdList.length)
        this.selectValueChange()
      },
      onSelect (opt) {
        console.log(opt)
        this.current.value.instanceIdList.splice(0, this.current.value.instanceIdList.length, opt.value)
        this.selectValueChange()
      },
      // 下拉框选择变化
      selectValueChange() {

        this.current.deleteInstanceList.splice(0, this.current.deleteInstanceList.length)
        this.current.addInstanceList.splice(0, this.current.addInstanceList.length)

        this.currentValue.instanceIdList.forEach(id => {
          if (!this.current.value.instanceIdList.includes(id)) {
            // 过滤出删除的id
            this.current.deleteInstanceList.push(id)
          }
        })
        this.current.value.instanceIdList.forEach(id => {
          if (!this.currentValue.instanceIdList.includes(id)) {
            // 过滤出增加的id
            this.current.addInstanceList.push(id)
          }
        })
        this.current.value.appId = this.current.relateAppId
        this.current.value.formId = this.current.relateFormId
        this.current.value.viewId = this.current.relateViewId
        this.controlChange()
        this.submitData()
      }
    },
    watch: {
      'current.value.instanceIdList'() {
        console.log('watch-change', this.current.value.instanceIdList)
        this.fetchSubmitFilterData()
      }
    }
  }
</script>

<style lang="less">

  .ry-form__item-relate-record {
    background-color: #ffffff;

    .record-container {

      .add-btn {
        color: #666;
        background: #f7f7fb;
        padding: 0 16px;
        cursor: pointer;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        width: 100%;
      }

      > .ry-form__dropdown-input {
        justify-content: space-between !important;
      }
    }

    .data-source-container {

      .card-item {
        padding: 10px 5px 10px 0;
        position: relative;
        width: 100%;

        .preview-card {
          position: relative;
          background-color: #fff;
          display: flex;
          border-radius: 5px;
          border: 1px solid #ebeef5;
          overflow: hidden;
          color: #303133;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);

          .preview-card-wrapper {
            display: flex;
            flex: 1 1;
            width: calc(100% - 5px);
            position: relative;

            .card-info {
              flex: 1 1;
              width: calc(100% - 100px);
              border-radius: 2px;
              padding-left: 10px;

              h3 {
                height: 18px;
                font-size: 16px;
                font-weight: 700;
                color: #262626;
                line-height: 18px;
                margin: 10px 0 10px 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .card-info-row {
                display: flex;
                flex: 1 1;
                margin-top: 10px;

                .row-item {
                  flex: 1 1;

                  h5 {
                    font-size: 11px;
                    color: #979797;
                    line-height: 16px;
                    margin: 0;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    word-wrap: break-word;
                  }

                  .item-content {
                    height: 31px;
                    display: flex;
                    align-items: center;
                    font-size: 14px;

                    > div {
                      padding-left: 0;
                      padding-right: 0;
                      margin-right: 8px;
                      overflow: hidden;
                      flex-wrap: nowrap;
                      line-height: 24px;
                      flex-grow: 1;
                      word-break: break-all;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    }
                  }
                }
              }
            }

            .img-container {
              border-radius: 1px;
              /*border: 1px solid #f0f0f6;*/
              display: flex;
              justify-content: center;
              align-items: center;

              .el-image {
                width: 90px;
                height: 90px;
              }
            }
          }
        }

        .delete-button {
          position: absolute;
          z-index: 1;
          right: -2px;
          top: 0;
          width: 20px;
          height: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;

          i {
            font-size: 16px;
            color: #6d6d6d;
          }
        }
      }

      .select {
        border: 1px solid #4A66FA;

        &:before {
          content: " ";
          z-index: 1;
          width: 31px;
          height: 31px;
          position: absolute;
          left: 0;
          top: 0;
          -webkit-transform: translate(-50%, -50%) rotate(45deg);
          transform: translate(-50%, -50%) rotate(45deg);
          background-color: #4A66FA;
        }

        &:after {
          content: " ";
          z-index: 1;
          left: 3px;
          top: 6px;
          width: 5px;
          height: 8px;
          position: absolute;
          display: table;
          border: 1px solid #fff;
          border-top: 0;
          border-left: 0;
          -webkit-transform: rotate(45deg) scale(1) translate(-50%, -50%);
          transform: rotate(45deg) scale(1) translate(-50%, -50%);
          opacity: 1;
          -webkit-transition: all .2s cubic-bezier(.12, .4, .29, 1.46) .1s;
          transition: all .2s cubic-bezier(.12, .4, .29, 1.46) .1s
        }
      }

      .preview-photo {
        margin: 10px 5px;
        position: relative;
        width: calc(50% - 10px);
        background-color: #fff;
        border-radius: 10px;
        border: 1px solid #ebeef5;
        overflow: hidden;
        color: #303133;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);

        .img-container {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 200px;

          .van-image {
            width: 100%;
            height: 200px;
          }
        }

        .card-info {
          padding: 10px 10px 0 10px;

          .title {
            display: flex;
            align-items: center;

            .color {
              width: 5px;
              height: 16px;
              margin-right: 5px;
            }

            h3 {
              height: 18px;
              font-size: 16px;
              font-weight: 700;
              color: #262626;
              line-height: 18px;
              margin: 10px 0;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }


          p {
            font-size: 13px;
            margin: 0 0 10px 0;
            color: #959699;
          }

          .card-info-row {

            .row-item {
              flex: 1 1;
              margin: 10px 0;

              h5 {
                font-size: 11px;
                color: #979797;
                line-height: 16px;
                margin: 0;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                word-wrap: break-word;
              }

              .item-content {
                height: 26px;
                display: flex;
                align-items: center;
                color: #262626;
                font-size: 14px;

                > div {
                  padding-left: 0;
                  padding-right: 0;
                  margin-right: 8px;
                  overflow: hidden;
                  flex-wrap: nowrap;
                  line-height: 24px;
                  flex-grow: 1;
                  word-break: break-all;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }
            }
          }
        }
      }
    }

    .relate-record-action-sheet {

    }
  }

</style>
